// POSTs to a Craft action and resolves with the parsed JSON response.
//
// The body is JSON: Craft reads JSON request bodies natively, so nested values like the
// directory's criteria need no query-string library. Anything but a 2xx JSON response
// rejects -- an HTML error page or a 401 from the staging password included -- so callers
// land in their error handling rather than treating it as an empty result.
export default {
  async post(url, data = {}) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status ${response.status}`);
    }

    return response.json();
  },
};
